import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isLogin } from '../../utils/Session';

const PrivateRoute = () => {
    const [isUserLoggedIn, setLoginState] = useState();
    useEffect(() => {
        isLogin().then(isLoggedIn => setLoginState(isLoggedIn));
    }, []);

    return isUserLoggedIn === undefined ? null : isUserLoggedIn ? <Outlet /> : <Navigate to="/auth/login" />;

};

export default PrivateRoute;